import React from "react";
import styles from "./STCareerDetail.module.css";
import { STHeroCommon } from "../STHeroCommon";
import { Icons } from "@/const/icons";
import Link from "next/link";
import clsx from "clsx";
import { STButton } from "../STButton";
import { careerHeroImg } from "../../assets/images";
import Image from "next/image";
import { STCareerHero } from "../STCareerHero";
import { useRouter } from "next/router";
import { STSharePopover } from "../STSharePopover";
export const STCareerDetail = ({ job }) => {
  const router = useRouter();
  if (!job) return null;

  return (
    <>
      <STCareerHero />
      <section className="space-md-pt space-xl-pb">
        <div className="container">
          <Link
            href="/career"
            className={clsx(
              styles.backBtn,
              "d-inline-flex align-items-center gap-2 space-md-mb",
            )}
          >
            {Icons.arrowLeft}
            <span>Go back</span>
          </Link>

          <div
            className={clsx(
              "d-flex justify-content-between align-items-start flex-wrap gap-xs space-md-mb",
            )}
          >
            <div className="">
              <h1 className="primary-title space-xs-mb">{job.title}</h1>
              <div className="d-flex gap-xs flex-wrap">
                <div
                  className={clsx(
                    "d-inline-flex align-items-center gap-2 text-clr-black-55",
                  )}
                >
                  {Icons.pinIcon}
                  <h5 className="mb-0 fw-normal">{job.location}</h5>
                </div>

                <div
                  className={clsx(
                    "d-inline-flex align-items-center gap-2 text-clr-black-55",
                  )}
                >
                  {Icons.bagIcon}
                  <h5 className="mb-0 fw-normal">{job.type}</h5>
                </div>
              </div>
            </div>
            <div className="d-flex gap-xs">
              <STButton
                className={styles.applyBtn}
                suffix={Icons.arrowRight}
                onClick={() => router.push(`/career/${job.slug}/apply`)}
              >
                Apply Now
              </STButton>
              <STSharePopover title="Share Job">
                <button
                  className={clsx(
                    styles.iconBtn,
                    "d-flex justify-content-center align-items-center rounded-circle text-clr-blue transition-smooth",
                  )}
                >
                  {Icons.shareIcon}
                </button>
              </STSharePopover>
            </div>
          </div>

          {job.description ? (
            <div className={styles.jobDetailWrapper}
              dangerouslySetInnerHTML={{ __html: job.description }}
            />
          ) : (
            <div className={styles.jobDetailWrapper}>
              <p className="paragraph-text mb-0">No description provided.</p>
            </div>
          )}
        </div>
      </section >
      <div className="bg-clr-black space-md-py">
        <div className="container">
          <h5 className="fw-normal mb-0 text-clr-white text-center lh-base">
            We are an equal opportunity employer and value diversity. All
            employment decisions are based on qualifications, merit, and
            business needs.
          </h5>
        </div>
      </div>
    </>
  );
};
